import { ListOfEmployeeGroupResponse } from './Api/ListOfEmployeeGroup.response';

export class ListOfEmployeeGroupEntity extends ListOfEmployeeGroupResponse {
	public static tryCast(o: any) {
		return Object.assign(new ListOfEmployeeGroupEntity(), o);
	}
}
